import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { useDeviceInfo } from '../../../../hooks/useDeviceInfo';

const Wrapper = styled.div`
  display: flex;
  height: ${props => (props.isMobile ? 'auto' : '90px')};
`;

const VehicleImage = styled.div`
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: ${props => (props.isMobile ? 'auto' : '90px')};
  width: ${props => (props.isMobile ? '100%' : '120px')};
  cursor: pointer;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  aspect-ratio: 4 / 3;
`;

export const TransactionImageComponent = ({ vehicle }) => {
  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (!vehicle) return;
    dispatch(push(`/vehicles/${vehicle.id}/view`));
  };

  const { isMobile } = useDeviceInfo();

  const vehicleImageSrc = vehicle?.preview_image?.url;

  return (
    <Wrapper isMobile={isMobile}>
      <VehicleImage isMobile={isMobile} imageUrl={vehicleImageSrc} onClick={handleOnClick} />
    </Wrapper>
  );
};
